import React, { useEffect, useState } from 'react';
import CustomTable from '../../../components/Table/CustomTable';
import { FaEllipsisH, FaPlusCircle } from 'react-icons/fa';
import { Button, Datepicker, Dropdown } from 'flowbite-react';
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout';
import downloadIcon from '../../../assets/document-download.png';
import filterIcon from '../../../assets/filterIcon.png';
import modalIcon from '../../../assets/Featured icon (2).png';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import PaymentModalContent from './PaymentModalContent';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import { PaymentLinksData, ColumnPaymentLinks } from '../../../types/TablesTypes/PaymentLinks';
import { numberWithCommas } from '../../../utils/formatNumber';
import PaymentLinkMenu from '../../../components/PaymentLinkMenu/PaymentLinkMenu';
import CustomModal from '../../../components/Modal/CustomModal';
import PaginationComponent from '../../../components/Pagination/PaginationComponent';
import PaymentLinkDetails from './PaymentLinkDetails';
import { createPortal } from 'react-dom';
import CustomDropdown from '../../../components/CustomDropdown/CustomDropdown';

const StatusView = ({ status, green, orange, red }: any) => {
    return (
        <div>
            {status === red ? (
                <div className='bg-red-200 flex items-center justify-center rounded'>Inactive</div>
            ) : status === orange ? (
                <div className='bg-orange-200 flex items-center justify-center rounded'>{orange}</div>
            ) : status === green ? (
                <div className='bg-green-200 flex items-center justify-center rounded'>Active</div>
            ) : null}
        </div>
    );
};

const Payment = () => {
    const [filters, setFilters] = useState({
        toDate: "",
        fromDate: "",
        status: "",
        // Page:"",
        // Limit:"",
        // Size:""
    });
    const [paymentLinks, setPaymentLinks] = useState<any>();
    const [tableRow, setTableRow] = useState<any[]>();
    const [bearer, setBearer] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true);
    const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false)
    const [selectedDetails, setSelectedDetails] = useState<any>(null)
    const handleFilterChange = (filterName: string, value: string) => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState<number>(0)
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await fetchPaymentLinks();
            setLoading(false)
        };
        fetchData();
    }, [filters, bearer, currentPage]);

    const fetchPaymentLinks = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/payment/link/subsidiary';
            const params = new URLSearchParams({
                ...filters,
                page: currentPage.toString(),
                limit: itemsPerPage.toString(),
            }).toString();
            const response = await client.get(`${apiUrl}?${params}`);
            setCurrentPage(response.data.currentPage)
            setTotalPages(response.data.totalPages || 1)
            setPaymentLinks(response.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const handleCopyLink = (linkUrl: string) => {
        navigator.clipboard.writeText(linkUrl).then(
            () => showToast("Link copied successfully", "success"),
            (err) => showToast('Failed to copy link', 'error')
        );
    }

    const handleActivateOrDeactivate = async (status: boolean, reference: string) => {
        let action;

        status ? action = "disable" : action = "activate";
        let payload = {
            action: action,
            reference: reference
        }

        try {

            const response = await client.post('/subsidiary/dashboard/payment/link/update-status', payload);
            const message = response?.data?.message;
            showToast(message, "success")
            fetchPaymentLinks()

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }

    const handleDetailsClick = (linkDetails: any) => {
        setSelectedDetails(linkDetails)
        setOpenDetailsModal(true)
    }

    const handleInitiatePayment = (linkUrl: string) => {
        window.open(linkUrl)
    }

    const dataPaymentLinks = () => {
        const tempArr: PaymentLinksData[] = [];
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        paymentLinks?.items
            ?.slice(startIndex, endIndex)
            .forEach((paymentLink: any, index: number) => {
                tempArr.push({
                    name: paymentLink?.name,
                    paymentType: paymentLink?.paymentType,
                    limit: paymentLink?.limit ?? "No limit",
                    currency: paymentLink?.currency,
                    amount: !paymentLink?.amount ? "ANY AMOUNT" : `${paymentLink?.currency} ${numberWithCommas(
                        paymentLink?.amount
                    )}`,
                    isActive: (
                        <StatusView
                            status={paymentLink?.isActive}
                            green={true}
                            red={false}
                        />
                    ),
                    action: (

                        // <div>

                        //     <PaymentLinkMenu
                        //         menuItems={[
                        //             paymentLink?.isActive ? "Deactivate Link" : "Activate Link",
                        //             "View Details",
                        //             "Copy Link",
                        //             "Initiate Payment"
                        //         ]}
                        //         linkInfo={paymentLink}
                        //         onViewDetails={() => { }}
                        //         onCopyLink={handleCopyLink}
                        //         onDeactivate={() => handleActivateOrDeactivate(paymentLink?.isActive, paymentLink?.reference)}
                        //         onInitiatePayment={handleInitiatePayment}
                        //     />
                        // </div>
                        // <div className="relative">
                        //     <Dropdown
                        //         inline
                        //         label={<FaEllipsisH />}
                        //         arrowIcon={false}
                        //         placement="right-start"
                        //         className="relative"
                        //     >
                        //         <div className="absolute right-0 z-50 bg-white shadow-lg rounded-md max-h-60 overflow-y-auto w-48">
                        //             <Dropdown.Item onClick={() => handleActivateOrDeactivate(paymentLink?.isActive, paymentLink?.reference)}>{paymentLink?.isActive ? "Deactivate Link" : "Activate Link"}</Dropdown.Item>
                        //             <Dropdown.Item onClick={()=>handleDetailsClick(paymentLink)} >View Details</Dropdown.Item>
                        //             <Dropdown.Item onClick={()=>handleCopyLink(paymentLink.paymentLinkUrl)}>Copy Link</Dropdown.Item>
                        //             <Dropdown.Item onClick={()=>handleInitiatePayment(paymentLink.paymentLinkUrl)}>Initiate Payment</Dropdown.Item>
                        //         </div>
                        //     </Dropdown>
                        // </div>
                        <CustomDropdown
                            paymentLink={paymentLink}
                            handleActivateOrDeactivate={handleActivateOrDeactivate}
                            handleDetailsClick={handleDetailsClick}
                            handleCopyLink={handleCopyLink}
                            handleInitiatePayment={handleInitiatePayment}
                        />


                    ),
                });
            });
        return tempArr;
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleLinkAdded = async () => {
        await fetchPaymentLinks();
        handleCloseModal()
    };

    useEffect(() => {
        setTableRow(dataPaymentLinks());
    }, [paymentLinks?.items]);

    return (
        <>
            <DashboardPagesTemplate
                apiUrl='/subsidiary/dashboard/payment/link/subsidiary'
                title='Payments'
                data={tableRow ? tableRow : []}
                show={openModal}
                openModal={() => setOpenModal(true)}
                closeModal={handleCloseModal}
                modalIcon={modalIcon}
                filters={filters}
                onFilterChange={setFilters}
                children={< PaymentModalContent close={() => handleCloseModal()} onLinkAdded={fetchPaymentLinks} />}
                exportButtonExists={false}
                dropdownItems={["All", "Active", "InActive"]}
                buttonLabel='Create New Link'
                buttonIcon={< FaPlusCircle />}
                showSearch={false}
                headings={ColumnPaymentLinks}
                ctaButtonExists={true}
                emptyMessage='You do not have any payment links yet'
                statusKey='status'
                loading={loading}
                tableContainerClass=''
            />
            <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} itemsNumber={totalPages != 0 ? totalPages : 1} />
            <CustomModal dismissible size="md" onClose={() => setOpenDetailsModal(false)} icon="" show={openDetailsModal}>
                <PaymentLinkDetails paymentLink={selectedDetails} close={() => setOpenDetailsModal(false)} />
            </CustomModal>
        </>
    );
};

export default Payment;
